<template lang="pug">
    .tabs-panel(:id="$toDashedString(headerName)",:class="{'is-active': active}")
        slot
</template>
<script type="text/babel">
    export default{
        name: "TabContent",
        components: {},
        data(){
            return {}
        },
        mounted() {
        },
        props: ['headerName', 'id','active']
    }
</script>
<style lang="sass" rel="stylesheet/sass">
    .dropdown-placeholder
        cursor: pointer
</style>


// WEBPACK FOOTER //
// TabContent.vue?4a04f9bc